import { Component, Prop, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-push-button-content',
  shadow: false,
  scoped: true,
  styleUrl: 'push-button.scss',
})
export class PushButtonContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   // @Event() click!: EventEmitter; // populates

   render() {
    return (
      <div class="content">
        <lar-button-push
          color={this.color}
          disabled={this.disabled}
        />
      </div>
    );
  }
}